import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const TABS = [
  { key: "state", label: "State" },
  { key: "city", label: "City" },
  { key: "religion", label: "Religion" },
  { key: "caste", label: "Caste" },
];

function ExploreProfilesBy({ defaultTab = "state", title = "" }) {
  const initialTab = TABS.some((t) => t.key === defaultTab) ? defaultTab : "state";
  const [activeTab, setActiveTab] = useState(initialTab);
  const [menus, setMenus] = useState({
    state: [],
    city: [],
    religion: [],
    caste: [],
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setActiveTab(TABS.some((t) => t.key === defaultTab) ? defaultTab : "state");
  }, [defaultTab]);

  useEffect(() => {
    const fetchMenus = async () => {
      setLoading(true);
      try {
        const results = await Promise.all(
          TABS.map(async (tab) => {
            const res = await fetch(
              `${process.env.REACT_APP_BASE_URL_API}/api/front/cms-menu/${tab.key}`
            );
            const data = await res.json();
            return [tab.key, data.status ? data.data || [] : []];
          })
        );
        setMenus(Object.fromEntries(results));
      } catch (err) {
        console.error("ExploreProfilesBy fetch error:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchMenus();
  }, []);

  const items = menus[activeTab] || [];

  return (
    <section className="exploreProfilesBy pt-50 pb-50">
      <div className="site-width">
        <h2
          style={{
            fontSize: 28,
            fontWeight: 700,
            color: "#222",
            marginBottom: 18,
          }}
        >
          {title || "Bihar’s No.1 Matrimony App"}
        </h2>

        <div
          className="exploreTabs"
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: 28,
            borderBottom: "1px solid #e5e5e5",
            marginBottom: 20,
          }}
        >
          {TABS.map((tab) => {
            const isActive = activeTab === tab.key;
            return (
              <button
                key={tab.key}
                type="button"
                onClick={() => setActiveTab(tab.key)}
                style={{
                  background: "none",
                  border: "none",
                  padding: "0 0 10px",
                  marginBottom: -1,
                  cursor: "pointer",
                  fontSize: 16,
                  fontWeight: isActive ? 700 : 500,
                  color: isActive ? "#222" : "#777",
                  borderBottom: isActive
                    ? "3px solid #222"
                    : "3px solid transparent",
                }}
              >
                {tab.label}
              </button>
            );
          })}
        </div>

        <div className="exploreTabContent">
          {loading && items.length === 0 ? (
            <p style={{ color: "#888" }}>Loading...</p>
          ) : items.length === 0 ? (
            <p style={{ color: "#888" }}>No items found</p>
          ) : (
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                alignItems: "center",
                rowGap: 10,
                columnGap: 0,
                lineHeight: 1.8,
              }}
            >
              {items.map((item, index) => (
                <React.Fragment key={item._id || item.slug}>
                  <Link
                    to={
                      item.path ||
                      (activeTab === "city"
                        ? `/city/${item.stateSlug || "bihar"}/${item.slug?.endsWith("-matrimony") ? item.slug : `${item.slug}-matrimony`}`
                        : `/${activeTab}/${item.slug?.endsWith("-matrimony") ? item.slug : `${item.slug}-matrimony`}`)
                    }
                    style={{
                      color: "#444",
                      textDecoration: "underline",
                      fontSize: 15,
                      whiteSpace: "nowrap",
                    }}
                  >
                    {item.name} 
                  </Link>
                  {index < items.length - 1 ? (
                    <span style={{ color: "#999", margin: "0 10px" }}>|</span>
                  ) : null}
                </React.Fragment>
              ))}
            </div>
          )}
        </div>
      </div>
    </section>
  );
}

export default ExploreProfilesBy;
